import { memo } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const CloseSvg = (props: SvgIconProps) => (
    <SvgIcon xmlns="https://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
        <g id="Calque_2" data-name="Calque 2">
            <g id="Calque_1-2" data-name="Calque 1">
                <path d="M15.85,15.15,8.71,8l6.14-6.15a.48.48,0,0,0,0-.7.48.48,0,0,0-.7,0L8,7.29.85.15a.48.48,0,0,0-.7,0,.48.48,0,0,0,0,.7L7.29,8,.15,15.15a.48.48,0,0,0,0,.7A.47.47,0,0,0,.5,16a.47.47,0,0,0,.35-.15L8,8.71l7.15,7.14a.48.48,0,0,0,.7,0A.48.48,0,0,0,15.85,15.15Z" />
            </g>
        </g>
    </SvgIcon>
);

export default memo(CloseSvg);
